import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetPricingCategoriesResponseBody, IPricingCategory } from './types';

export const getPricingCategories = async (priceSchemeId: string): Promise<IPricingCategory[]> => {
  const url = `${API_URL}/pricing/schemes/${priceSchemeId}/categories`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch pricing categories');
  }
  const json: IGetPricingCategoriesResponseBody = await response.json();
  return json.data;
};
